import _ from 'lodash';
import vehicleService from '@/services/vehicleService';
import SMP_CONFIG from '@/util/smp_config';

const configureTopServices = function ({ commit, rootState }) {
  let code = rootState.vehicleIdentification.vehicleType.ecode || rootState.vehicleIdentification.vehicleType.fiCode;
  let params = vehicleService.decodeFicode(code);
  let topServiceCategoryGroup;
  let servicesByTags;
  params.offset = 0;
  params.max = 1000;
  return vehicleService.getServices(params)
    .then(function (res) {
      let services = res.data;
      topServiceCategoryGroup = _.cloneDeep(SMP_CONFIG.applicationConfig.serviceSelectionConfig.topServiceCategoryGroup);
      servicesByTags = {};
      let listServicesByTagPromises = [];
      _.each(topServiceCategoryGroup.serviceCategories, function (serviceCategory) {
        _.each(serviceCategory.serviceGroups, function (serviceGroup) {
          let tag = serviceGroup.serviceTag;
          if (tag) {
            let listByTagParams = _.extend({ tag: tag }, params);
            listServicesByTagPromises.push(
              vehicleService.getServices(listByTagParams).then(function (tagServices) {
                servicesByTags[tag] = tagServices.data;
              })
            );
          } else {
            _.each(serviceGroup.services, function (topService) {
              let service = _.find(services, { externalId: topService.externalId });
              if (service) {
                topService = _.extend(topService, service);
              }
            });
          }
        });
      });

      return Promise.all(listServicesByTagPromises)
    })
    .then(function (res) {
      _.each(topServiceCategoryGroup.serviceCategories, function (serviceCategory) {
        _.each(serviceCategory.serviceGroups, function (serviceGroup) {
          let tag = serviceGroup.serviceTag;
          if (tag) {
            serviceGroup.services = servicesByTags[tag];
          }
        });
      });
      return res;
    })
    .then(function () {
      _.each(topServiceCategoryGroup.serviceCategories, function (serviceCategory) {
        _.each(serviceCategory.serviceGroups, function (serviceGroup) {
          serviceGroup.services = _.filter(serviceGroup.services, function (topService) {
            return topService.id;
          });
          if (serviceGroup.services && serviceGroup.services.length) {
            serviceGroup.open = true;
          }
        });
        serviceCategory.serviceGroups = _.filter(serviceCategory.serviceGroups, function (serviceGroup) {
          return serviceGroup.services && serviceGroup.services.length;
        });
        if (serviceCategory.serviceGroups && serviceCategory.serviceGroups.length && !serviceCategory.collapsed) {
          serviceCategory.open = true;
        }
      });
      topServiceCategoryGroup.serviceCategories = _.filter(topServiceCategoryGroup.serviceCategories, function (serviceCategory) {
        return serviceCategory.serviceGroups && serviceCategory.serviceGroups.length;
      });
      commit('SET_TOP_SERVICE', topServiceCategoryGroup);
      return topServiceCategoryGroup;
    });
};

const addService = ({ commit, state, rootState }, service) => {
  commit('ADD_SERVICE', service);
};

const removeService = ({ commit }, service) => {
  commit('REMOVE_MAINTENANCE_POSITIONS', service);
  commit('REMOVE_SERVICE', service);
};

const setMaintenancePositionsToService = function({ commit }, maintenancePositionsObj) {
  return commit('ADD_MAINTENANCE_POSITIONS_TO_SERVICE', maintenancePositionsObj);
};

const getMaintenancePositions = function({ commit, rootState }, service) {
  return vehicleService.getMaintenancePositions(service, rootState)
    .then((res) => {
      commit('SET_MAINTENANCE_POSITIONS', res.data);
      return res;
    });
};

export default {
  configureTopServices,
  addService,
  removeService,
  getMaintenancePositions,
  setMaintenancePositionsToService
};
